import React, { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { TextComponent } from "./TextComponent";
const RadioGroupComponent = ({
  defaultValue,
  options,
  didSelectOption,
  title
}) => {
  const [selected, setSelected] = useState(defaultValue ? defaultValue : options[0]);
  const [haveNotifiedAboutDefaultFallback, sethaveNotifiedAboutDefaultFallback] = useState(false);
  const onChange = value => {
    setSelected(value);
    didSelectOption(value);
  };
  useEffect(() => {
    if (!defaultValue && !haveNotifiedAboutDefaultFallback) {
      didSelectOption(selected);
      sethaveNotifiedAboutDefaultFallback(true);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioGroup, {
    value: selected,
    by: "value",
    onChange: val => onChange(val)
  }, /*#__PURE__*/React.createElement(RadioGroup.Label, null, title), /*#__PURE__*/React.createElement("div", {
    className: "space-y-2 py-2"
  }, options.map((option, i) => {
    return /*#__PURE__*/React.createElement(RadioGroupOptionComponent, {
      option: option,
      key: i
    });
  })))));
};
const RadioGroupOptionComponent = ({
  option
}) => {
  return /*#__PURE__*/React.createElement(RadioGroup.Option, {
    value: option,
    className: ({
      active,
      checked
    }) => `
                  ${checked ? "ring-2 ring-purple-700 bg-purple-50" : "ring-1 ring-gray-200 hover:ring-2 hover:ring-purple-300"}
                    relative flex cursor-pointer rounded-lg px-4 py-4 focus:outline-none`
  }, ({
    active,
    checked
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, option.icon, /*#__PURE__*/React.createElement("div", {
    className: "pl-3"
  }, /*#__PURE__*/React.createElement(RadioGroup.Label, null, /*#__PURE__*/React.createElement(TextComponent, null, option.label)), /*#__PURE__*/React.createElement(RadioGroup.Description, {
    as: "span"
  }, /*#__PURE__*/React.createElement(TextComponent, {
    size: "sm"
  }, option.description)))), checked && /*#__PURE__*/React.createElement("div", {
    className: "shrink-0 text-purple-600"
  }, /*#__PURE__*/React.createElement(CheckCircleIcon, {
    className: "h-6 w-6"
  })))));
};
export { RadioGroupComponent };